import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { Action, bindActionCreators } from 'redux';

export type ActionFactory<TArgs = undefined> = (args?: TArgs) => Action;

export function useAction<TArgs, T extends ActionFactory<TArgs>>(action: T): T {
	const dispatch = useDispatch();
	const boundAction = useMemo(() => bindActionCreators(action, dispatch), [ action, dispatch ]);

	return boundAction;
}
